import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpCancelService {
  pendingHTTPRequest$ = new Subject<void>();

  /**
   * Method that cancels all pending requests on route change.
   */
  cancelAllRequests() {
    this.pendingHTTPRequest$.next();
  }
}
